import SubjectCard from '../components/views/SubjectCard';
import SubjectPage from '../components/views/SubjectPage';

export interface DynamicTabContent {
  [key: string]: any;
}

// przypisanie randerowanego komponentu do typu dynamicznej zakładki
export const dynamicTabContent: DynamicTabContent = {
  'karta-przedmiotu': SubjectCard,
  'strona-przedmiotu': SubjectPage,
};
